import type { CtSearchProductsFacet, CtRefinementListItem } from '~~/types/productListing/CtSearchProductsResult';

// Tags are a JSON array in one ltext field, so CT buckets whole combinations
// (e.g. '["bestseller","on-sale"]'). Split them into one item per tag and sum the counts.
export const mapCtTagsFacetToRefinementItems = (
  facet: CtSearchProductsFacet | undefined,
  selectedValues: string[] = [],
): CtRefinementListItem[] => {

  const countByTag = new Map<string, number>();

  (facet?.buckets || []).forEach((bucket) => {

    let tags: unknown;

    try {

      tags = JSON.parse(bucket.key);

    } catch {

      return;

    }

    if (!Array.isArray(tags)) {

      return;

    }

    tags.forEach((tag) => {

      if (typeof tag !== 'string' || !tag) {

        return;

      }

      countByTag.set(tag, (countByTag.get(tag) || 0) + bucket.count);

    });

  });

  return Array.from(countByTag.entries()).map(([tag, count]) => {

    const item: CtRefinementListItem = {
      value: tag,
      label: tag,
      count,
      isRefined: selectedValues.includes(tag),
    };

    return item;

  });

};
